// extracted by mini-css-extract-plugin
export default {"modalAccordion":"FenceCanvasModals_modalAccordion__-yusb"};